import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JavascriptInjectorService {

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  injectToHtmlHead(script: string) {
    let node = document.createElement('script');
    node.type = 'text/javascript';
    node.innerHTML = script;
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  downloadAndRunExternalScript(scriptsUrls: string[]) {
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src')?.includes("loader")) {
        isFound = true;
      }
    }

    if (!isFound) {
      for (var i = 0; i < scriptsUrls.length; i++) {
        let node = document.createElement('script');
        node.src = scriptsUrls [i];
        node.type = 'text/javascript';
        node.async = false;
        node.defer = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
    else {
      console.error("External scripts not loaded.");
    }
  }
}
